import React from 'react';
import {
  Col,
  FormGroup,
  FormGroupProps,
  FormLabel,
  FormLabelProps,
  FormText,
  FormTextProps,
  Row,
} from 'react-bootstrap';
import { FormikControl, FormikControlProps } from '../';
import { useControlId, useLabel } from '../FormGroupBase';

type FormGroupControlProps = FormikControlProps & {
  label?: string;
  help?: string;
  labelProps?: FormLabelProps;
  groupProps?: FormGroupProps;
  helpProps?: FormTextProps;
  asRow?: boolean;
};

const FormGroupControl = ({
  label,
  help,
  labelProps,
  groupProps,
  helpProps,
  asRow = false,
  ...props
}: FormGroupControlProps) => {
  const { required, name } = props;
  const controlId = useControlId(name);
  const labelText = useLabel(label, required);

  if (asRow) {
    return (
      <FormGroup as={Row} {...groupProps} controlId={controlId}>
        <FormLabel column sm={4} {...labelProps}>
          {labelText}
        </FormLabel>
        <Col sm>
          <FormikControl {...props} />
          {help && (
            <FormText muted {...helpProps}>
              {help}
            </FormText>
          )}
        </Col>
      </FormGroup>
    );
  }

  return (
    <FormGroup {...groupProps} controlId={controlId}>
      {labelText && <FormLabel {...labelProps}>{labelText}</FormLabel>}
      <FormikControl {...props} />
      {help && (
        <FormText muted {...helpProps}>
          {help}
        </FormText>
      )}
    </FormGroup>
  );
};

export { FormGroupControl, FormGroupControlProps };
